import { NgModule } from '@angular/core';
import { MatOptionModule, MatOptionSelectionChange } from '@angular/material/core';

export class TiimeOptionSelectionChange<T = any> extends MatOptionSelectionChange<T> {}

@NgModule({
  imports: [MatOptionModule],
  exports: [MatOptionModule]
})
export class TiimeOptionModule {}
